/* import __COLOCATED_TEMPLATE__ from './yielding-doughnut-chart.hbs'; */
import Component from '@glimmer/component';
import { htmlSafe } from '@ember/template';

const CLASS_NAME = 'SH-c-yielding-doughnut-chart';
const EMPTY_STATE_COLOR = '#E0E0E0';

class YieldingDoughnutChartComponent extends Component {
  get className() {
    return CLASS_NAME;
  }

  get canvasStyles() {
    const { height, width } = this.args;
    return htmlSafe(`
      --chart-height: ${height}px;
      --chart-width: ${width}px;
    `);
  }

  get datasets() {
    const { chartData, groupedChartGraphColors } = this.args;

    // show chart even when all values are zero
    if (chartData.every(value => value === 0)) {
      return [{
        data: [1],
        backgroundColor: [EMPTY_STATE_COLOR],
        borderWidth: [0],
      }];
    }

    return [{
      data: chartData,
      backgroundColor: groupedChartGraphColors,
    }];
  }

  get options() {
    const { height, width } = this.args;

    return {
      animation: false,
      cutout: '78%',
      defaultFontFamily: "'Inter', sans-serif",
      elements: {
        arc: {
          borderWidth: 0,
        }
      },
      events: [],
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          enabled: false,
        },
      },
      responsive: !(width && height),
    };
  }
}

export default YieldingDoughnutChartComponent;
